import { useSelector, useDispatch } from 'react-redux';
import FJActionImageToImage from '../../../redux/action/FJActionImageToImage';
import FJGeneratePrivacySettings from './FJGeneratePrivacySettings.jsx';
import useLocalStore from '../../../hooks/useLocalStore';

const FJGeneratePrivacySettingsContainer = () => {
    const dispatch = useDispatch();
    useLocalStore();
    const privacyStatus = useSelector(state => state.imageToImage.privacyStatus);

    const _onPrivacySettingChange = (value, callback) => {
        dispatch(FJActionImageToImage.setPrivacySettingAction(value));
        callback(true);
    };

    return <FJGeneratePrivacySettings privacyStatus={privacyStatus} onPrivacySettingChange={_onPrivacySettingChange} />;
};

export default FJGeneratePrivacySettingsContainer;
